const equipmentRouter = r => require.ensure([], () => r(require('@/page/equipmentAdministration/equipmentRouter')), 'equipmentAdministration');
const equipmentAdministration = r => require.ensure([], () => r(require('@/page/equipmentAdministration/equAdministration/equipmentAdministration')), 'equAdministration');
const maintenanceMge = r => require.ensure([], () => r(require('@/page/equipmentAdministration/maintenanceMge/maintenanceMge')), 'maintenanceMge');
const patrolRecordList = r => require.ensure([], () => r(require('@/page/equipmentAdministration/patrolRecord/patrolRecordList')), 'patrolRecordList');
const repairMge = r => require.ensure([], () => r(require('@/page/equipmentAdministration/repairMge/repairMge')), 'repairMge');
const addRepair = r => require.ensure([], () => r(require('@/page/equipmentAdministration/repairMge/addRepair')), 'addRepair');
const repairInfo = r => require.ensure([], () => r(require('@/page/equipmentAdministration/repairMge/repairInfo')), 'repairInfo');
const patrolRecordInfo = r => require.ensure([], () => r(require('@/page/equipmentAdministration/patrolRecord/patrolRecordInfo')), 'patrolRecordInfo');
const addMaintenance = r => require.ensure([], () => r(require('@/page/equipmentAdministration/maintenanceMge/addMaintenance/addMaintenance')), 'addMaintenance');
const detailMaintenance = r => require.ensure([], () => r(require('@/page/equipmentAdministration/maintenanceMge/detailMaintenance/detailMaintenance')), 'detailMaintenance');
const equAdministrationAccount = r => require.ensure([], () => r(require('@/page/equipmentAdministration/equAdministrationAccount/equAdministrationAccount')), 'equAdministrationAccount');
const equipmentMaintenance = r => require.ensure([], () => r(require('@/page/equipmentAdministration/equipmentMaintenance/equipmentMaintenance')), 'equipmentMaintenance');


const equipmentAdministrationRouter = {
    path: '',
    name: '设备设施',
    component: equipmentRouter,
    meta: {
        icon: 'equipmentAdministration',
        right: [],
        isShowMenu: true,
        keepAlive:true,
    },
    children: [{
            path: '/equAdministration',
            component: equipmentAdministration,
            name: '设备设施管理',
            meta: {
                right: ['物业设备变更'],
                isShowMenu: true,
                keepAlive:true,
            },
        }, {
            path: '/equAdministrationAccount',
            component: equAdministrationAccount,
            name: '设备设施台账',
            meta: {
                right: ['物业设备变更'],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/patrolRecordList',
            component: patrolRecordList,
            name: '巡检记录列表',
            meta: {
                right: ['设备巡检管理'],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/maintenanceMge',
            component: maintenanceMge,
            name: '维保管理',
            meta: {
                right: ['设备维保管理'],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/addMaintenance',
            component: addMaintenance,
            name: '新增维保',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/detailMaintenance',
            component: detailMaintenance,
            name: '维保详情',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/repairMge',
            component: repairMge,
            name: '报修管理',
            meta: {
                right: ['报修管理'],
                isShowMenu: true,
                keepAlive:true,
            },
        },
        {
            path: '/addRepair',
            component: addRepair,
            name: '报修登记',
            meta: {
                right: ['报修管理'],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/repairInfo',
            component: repairInfo,
            name: '报修详情',
            meta: {
                right: ['报修管理'],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/patrolRecordInfo',
            component: patrolRecordInfo,
            name: '巡检详情',
            meta: {
                right: ['设备巡检管理'],
                keepAlive:true,
            },
        },
        {
            path: '/equipmentMaintenance',
            component: equipmentMaintenance,
            name: '设备维保',
            meta: {
                right: ['设备巡检管理'],
                isShowMenu: true,
                keepAlive: false,
            },
        }

    ]
};
export default equipmentAdministrationRouter;
